module.exports = function getResource(label, vars = []) {
    let resources = {
        categories: 'Catégories',
        category: 'Catégorie'
    };
    return resources[label];
};
